import ReactDOM from "react-dom"; 
import CryptoJS from "crypto-js"; 
import cryptography from "./encrypt"

// import AboutJSON from "./about.json";
import HomeJSON from "./home.json";
import FQAJSON from "./faq.json";
import PricingPlanJSON from "./pricingPlan.json";
import ContactFormJSON from "./contactForm.json"
import ResumeJSON from "./resume.json"

import footerJson from "./footer.json";
import headerJson from "./header.json";
import React from "react";
import { Modal, IconList, Blocks, Images, VideosModel, ImageCropperModal } from "./helpers";
import config from "../config.json";
import { svgIcon } from "./utility";


export const elementBackground2 = function(backgroundColor) {
    const style = {
      backgroundSize:"",
      backgroundImage:""
    }
    if(backgroundColor)  {
        if(backgroundColor !== "") {
            if(backgroundColor.indexOf("__CDN__PATH__") !== -1) {
                style.backgroundImage = `url('${app.cdn(backgroundColor)}')`;
                style.backgroundSize = "cover";
                if(backgroundColor.indexOf("/patterns/") !== -1) {
                  style.backgroundSize = "120px 120px";
                }
            }
            else if(backgroundColor.indexOf("https://") !== -1 || backgroundColor.indexOf("http://") !== -1) {
              style.backgroundImage = `url('${backgroundColor}')`;
              style.backgroundSize = "cover";
            }
            else if(backgroundColor.indexOf("linear-gradient(") !== -1) {
              style.backgroundImage = backgroundColor;
              style.backgroundSize = "cover";
            }
            else {
              style.backgroundColor = backgroundColor;
              style.backgroundImage = `inherit`;
            }
        }
    }
    return style;
}

export const elementWeight = function(weight) {  
    if (weight) {
         if(weight === "medium"){
            return "500"
         }else if(weight === "bold"){
            return "700"
         }else if(weight === "italic"){
            return "italic"
         }
         else if(weight === "boldItalic"){
            return "800"
         }else{
            return "400"
         }
    } 
}

export class UndoRedo extends React.Component {
constructor(props) {
    super(props);
    this.state = {
      undo: app.getUndoRedo("undo"),
      redo: app.getUndoRedo("redo")
    }
    this.update = this.update.bind(this);
}
componentWillReceiveProps() {
    this.setState({
      undo: app.getUndoRedo("undo"),
      redo: app.getUndoRedo("redo")
    })
}
componentDidUpdate() {
  // const blocks = document.querySelectorAll(".block-view");
  // if(blocks.length) { 
    
  //   blocks[0].classList.add("first-child");
  //   blocks[blocks.length - 1].classList.add("last-child");

  //   const footerBlocks = document.querySelectorAll(".block-view.footer");
  //   if(footerBlocks.length) {
  //     footerBlocks[0].classList.add("first-child");
  //     footerBlocks[0].previousSibling.classList.add("last-child");
  //   }
  // }
}
update(e) {
  if(e.currentTarget.classList.contains("disabled")) {
    return false;
  }
    let a = null;
    let type = "undo";
    
    if (e.currentTarget.classList.contains("undo")) {
      let undo = app.getUndoRedo("undo");
      a = undo.pop();
      //app.saveRedo(a);
      app.setUndoRedo("undo", undo);
    }
    else {
      type = "redo";

      let redo = app.getUndoRedo("redo");
      a = redo.pop();
      //app.saveUndo(a);
      app.setUndoRedo("redo", redo);
    }
    this.props.update(a, type);
}
updateBtn(type) {
  if(document.querySelectorAll(".undo-btn, .redo-btn")) {
    if(document.querySelectorAll(".undo-btn, .redo-btn").length) {
      document.querySelectorAll(".undo-btn, .redo-btn").forEach(function(v){
        v.classList.remove("disabled");
      });
      if(type === "undo") {
        document.querySelector(".undo-btn").classList.add("disabled");
      }
      if(type === "redo") {
        document.querySelector(".redo-btn").classList.add("disabled");
      }
      if(type === "both") {
        document.querySelector(".undo-btn").classList.add("disabled");
        document.querySelector(".redo-btn").classList.add("disabled");
      }
    } 
  }
}

render() {
    let { undo, redo } = this.state;
    let disabledUndo = "";
    let disabledRedo = "";
    
    if (undo.length === 0 && redo.length === 0) {
      disabledUndo = "disabled";
      disabledRedo = "disabled";
      this.updateBtn("both");
    }
    else {
      this.updateBtn();
      if (undo.length === 0) {
        disabledUndo = "disabled";
        this.updateBtn("undo");
      }
      if (redo.length === 0) {
        disabledRedo = "disabled";
        this.updateBtn("redo");
      }
    }
   
    
    return <div className="undo-redo-container">
      <a className={`undo ${disabledUndo}`} onClick={this.update}>
        {svgIcon.undo}
      </a>
      <a className={`redo ${disabledRedo}`} onClick={this.update}>
        {svgIcon.redo} 
      </a>
    </div>
}
}
 

// Fallbacks for app.getDom() / app.getWin() when the editor's
// <iframe id="iframe"> isn't in the DOM. Both helpers are called from
// lifecycle callbacks and setTimeouts that can run before the iframe mounts
// or after it unmounts, and previously threw on `.contentWindow` of null —
// which bubbled to Sentry.ErrorBoundary and blanked the whole editor.
//
// The stubs keep those ~60 call sites non-fatal. querySelectorAll returns []
// (so .forEach is a no-op), querySelector returns null (its normal contract,
// which callers already have to handle), and body/head return a detached node
// so any writes land on a throwaway instead of leaking into the parent page.
let iframeDomStub = null;
let iframeWinStub = null;

const getIframeDomStub = function() {
  if(!iframeDomStub) {
    const detached = document.createElement("div");
    iframeDomStub = {
      __stub: true,
      body: detached,
      head: detached,
      documentElement: detached,
      // html/body/head always exist in a real document, so hand back the
      // detached node for those — keeps callers like
      // `getDom().querySelector("html").setAttribute(...)` non-fatal.
      // Everything else returns null, querySelector's normal contract.
      querySelector: function(sel){
        if(sel === "html" || sel === "body" || sel === "head") { return detached; }
        return null;
      },
      querySelectorAll: function(){ return []; },
      getElementById: function(){ return null; },
      createElement: function(tag){ return document.createElement(tag); },
      addEventListener: function(){},
      removeEventListener: function(){},
      execCommand: function(){ return false; }
    };
  }
  return iframeDomStub;
};

const getIframeWinStub = function() {
  if(!iframeWinStub) {
    iframeWinStub = {
      __stub: true,
      scrollX: 0,
      scrollY: 0,
      innerWidth: 0,
      innerHeight: 0,
      onclick: null,
      document: getIframeDomStub(),
      scrollTo: function(){},
      getSelection: function(){ return null; },
      addEventListener: function(){},
      removeEventListener: function(){}
    };
  }
  return iframeWinStub;
};

const app = {
  loadConfig:async function(){
    if(localStorage.getItem("aiConfig")) {
      return JSON.parse(localStorage.getItem("aiConfig"));
    }
    // Callers don't handle rejection: src/pages/index.js and src/pages/users.js
    // call this fire-and-forget, and src/pages/live.js does
    // .then(reloadApp) with no .catch — so a transient network failure both
    // surfaced as an unhandled rejection and left live.js never calling
    // reloadApp, i.e. the editor never appeared. Fall back to the bundled
    // config instead; it's the same source getConfig() uses when the cache is
    // empty. Deliberately not cached, so a later load can still fetch the
    // real thing.
    try {
      let response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
        method:"POST",
        body:JSON.stringify({
          "method":"getConfig",
          "lang":app.appLang()
        })
      });
      response = await response.json();
      localStorage.setItem("aiConfig", JSON.stringify(response));
      return response;
    }
    catch(err) {
      console.warn("app.loadConfig: request failed, using bundled config", err);
      return config;
    }
  },
  getConfig:function(){
    if(localStorage.getItem("aiConfig")) {
      return JSON.parse(localStorage.getItem("aiConfig"));
    }
    return config;
  },
  appLang:function(){
    //return "es";
    if(app.getProject() === "live") {
      return localStorage.getItem("lang")?localStorage.getItem("lang"):"en";
    }
    return "en";
  },
  saveImage:async function(path, data){
    let response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
      method:"POST",
      body:JSON.stringify({
        method:"saveImage",
        path,
        data
      })
    });
    return response;
  },
  saveAiImage:async function(appId, image){
    app.fetchPost({
        method:"saveAiImage",
        appId:appId,
        customImage:image
    })
  },
 
    loadPage:async function(){
        const jsonFileURL = 'https://api.npoint.io/666759e0f20ea8b26bde';
        let response = await fetch(jsonFileURL);
        return await response.json();
        
    },
    loadPage2:async function(page){ 
    // return HomeJSON;
      // if(page === '/' || page === 'home'){
      //   return HomeJSON;
      // }
      // else{
      //   let response = await fetch('https://api.mediadirhub.com/pages', {
      //     // let response = await fetch('https://api.npoint.io/e268f54ddfc4631be401', {
      //     method: 'POST',
      //     body: JSON.stringify({
      //       page
      //     }) 
      //   }) 
      //   try {
      //     return await response.json();
      //   } catch (error) {
      //     return AboutJSON;
      //   } 
      // }
      let response = await fetch('https://api.mediadirhub.com/pages', {
          // let response = await fetch('https://api.npoint.io/e268f54ddfc4631be401', {
          method: 'POST',
          body: JSON.stringify({
            page
          })
        }) 
        try {
          return await response.json();
        } catch (error) {
          return HomeJSON;
        } 
      //return AboutJSON;
    },
    localPage:function(){
      //return {dynamicAIData:[headerJson.headerAIData[0], footerJson.footerAIData[0]]}
      return {
        dynamicAIData:[headerJson.headerAIData[0], ...HomeJSON.dynamicAIData, footerJson.footerAIData[0]]
      }
      return {
        dynamicAIData:[...ResumeJSON.dynamicAIData]
      }
      return {
        dynamicAIData:[...ContactFormJSON.dynamicAIData]
      }
      return {
        dynamicAIData:[...PricingPlanJSON.dynamicAIData]
      }
    },
    savePage:async function(page, data){  
      // if(page === '/' || page === 'home'){
      //   return HomeJSON;
      // }
      // else{
      //   let response = await fetch('https://api.mediadirhub.com/pages', {
      //     method: 'POST',
      //     body: JSON.stringify({
      //       page,
      //       data:JSON.stringify(data)
      //     })
      //   })
      //   return await response.json();
      // }
      let response = await fetch('https://api.mediadirhub.com/pages', {
        method: 'POST',
        body: JSON.stringify({
          page,
          data:JSON.stringify(data)
        })
      })
      return await response.json();
     // return AboutJSON;
    },
    userImages:function(data) {
      if(data) {
        localStorage.setItem("userCustomImages", JSON.stringify(data));
      }
      else {
        let userImages = [];
        if (localStorage.getItem("userCustomImages")) {
          userImages = JSON.parse(localStorage.getItem("userCustomImages"));
        }
        return userImages;
      }
    },
    
    headerImages:function(data) {
      if(data) {
        localStorage.setItem("headerImages", JSON.stringify(data));
      }
      else {
        let headerImages = {
            app_header_image_potrait: "",
            app_header_image_landscape: "",
            headersmartphones: [
              { width: '200', height: '44', image: '' },
              { width: '320', height: '44', image: '' },
              { width: '375', height: '44', image: '' },
              { width: '414', height: '44', image: '' },
              { width: '480', height: '44', image: '' },
              { width: '750', height: '88', image: '' },
              { width: '800', height: '44', image: '' },
              { width: '980', height: '88', image: '' },
              { width: '1136', height: '88', image: '' },
              { width: '1242', height: '132', image: '' },
              { width: '1334', height: '88', image: '' },
              { width: '2208', height: '132', image: '' }
            ],
            headertabletphones: [
              { width: '640', height: '44', image: ''  }, 
              { width: '667', height: '44', image: ''  },
              { width: '720', height: '44', image: ''  },  
              { width: '1280', height: '44', image: ''  }, 
              { width: '1536', height: '88', image: ''  }, 
              { width: '2048', height: '88', image: ''  }
            ]
        };
        if (localStorage.getItem("headerImages")) {
          headerImages = JSON.parse(localStorage.getItem("headerImages"));
        }
        return headerImages;
      }
    },

    userVideos:function(data) { 
      if(data) {
        localStorage.setItem("userCustomVideos", JSON.stringify(data));
      }
      else {
        let userVideos = [];
        if (localStorage.getItem("userCustomVideos")) {
          userVideos = JSON.parse(localStorage.getItem("userCustomVideos"));
        }
        return userVideos;
      }
    },
    userAiImages:function(data) {
      if(data) {
        localStorage.setItem("userAiImages", JSON.stringify(data));
      }
      else {
        let userImages = [];
        if (localStorage.getItem("userAiImages")) {
          userImages = JSON.parse(localStorage.getItem("userAiImages"));
        }
        return userImages;
      }
    },
    savePageLive:async function(id, data){  
      app.fetchPost({
        method:"savePageData",
        appId:localStorage.getItem("aiAppId"),
        pageId:localStorage.getItem("aiPageId"),
        id:id,
        pageDataJson:JSON.stringify(data)
      }, true).then(function(response){
        console.log(response);
      })
    },
    getUndoRedo:function(){
        return [] 
    },
    getDom:function() {
      const frame = document.querySelector("#iframe");
      if(frame && frame.contentWindow && frame.contentWindow.document) {
        return frame.contentWindow.document;
      }
      // Iframe not mounted (or already torn down) — see getIframeDomStub().
      console.warn("app.getDom(): #iframe unavailable, returning stub");
      return getIframeDomStub();
    },
    getWin:function() {
      const frame = document.querySelector("#iframe");
      if(frame && frame.contentWindow) {
        return frame.contentWindow;
      }
      console.warn("app.getWin(): #iframe unavailable, returning stub");
      return getIframeWinStub();
    },
    loadCSS:function(file) {
        const link = document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        if(file.indexOf("https:") !== -1) {
          link.setAttribute("href", file);
        }
        else {
          link.setAttribute("href", `${window.aiHost}${file}?version=${window.aiVersion}`);
        }
        app.getDom().head.appendChild(link);
    },
    loadJS:function(file) {
      const link = document.createElement("script");
      // link.setAttribute("type", "text/js");
      if(file.indexOf("https:") !== -1) {
        link.setAttribute("src", file);
      }
      else {
        link.setAttribute("src", `${window.aiHost}${file}`);
      }
      app.getDom().head.appendChild(link);
    },
    iconPopup:function(callback) {
      const div = document.createElement("div");
      document.body.appendChild(div);
      ReactDOM.render(<Modal title="Select Icon">
        <IconList callback={callback} />
      </Modal>, div);
    },
  imagePopup:function(src, callback, key) {
      const div = document.createElement("div");
      // Marks this container as one the editor created, so CSS can raise it
      // above the Manage Menu popup without touching the host application's own
      // .modal elements — the builder page has ~74 of them.
      div.className = "ai-popup-layer";
      document.body.appendChild(div);
      ReactDOM.render(<Images src={src} type={key} callback={function(key, val){
        callback(key, val);
        if(document.querySelector(".modal .modal-close")){
          document.querySelector(".modal .modal-close").click();
        } 
      }} />, div);
  },
  validateImage:function(file, w, h){
    return new Promise(function(resolve, reject){
      let img = new Image()
      img.src = window.URL.createObjectURL(file)
      img.onload = () => {
          if(img.width === w && img.height === h){
            resolve(true);
            return false;
          }
          //resolve(true);
          reject(false)
      }
    });
  },
  cropingModel:function(e, id){
    return new Promise(function(resolve,reject){
      const fileInput = e.currentTarget.files;
      let width = e.currentTarget.getAttribute('width');
      let height = e.currentTarget.getAttribute('height');
      const type = e.currentTarget.getAttribute('data-type');
      let ratio = width/height;
      if(id === "logo") {
        width = 600;
        height = 200;
        ratio = null;
      }

      if (fileInput.length > 0) {
          const file = fileInput[0];
          const div = document.createElement("div");
          document.body.appendChild(div);
          ReactDOM.render(
              <ImageCropperModal 
                  file={file} 
                  width={width} 
                  height={height} 
                  type={type} 
                  ratio={ratio}
                  saveHeaderImages={(croppedFile) => {
                      // ReactDOM.unmountComponentAtNode(div);
                      div.remove();
                      resolve(croppedFile); // Pass the cropped image to the callback
                      app.preloader(true);
                  }} 
                  removeImage={() => {
                      // ReactDOM.unmountComponentAtNode(div);
                      div.remove();
                  }} 
              />,
              div
          );      
      }else{
        reject(new Error("No file selected"))
      }

    })
  },
  uploadLogo:function(event, id, callback) {
    if(event.currentTarget.files.length) {
      app.cropingModel(event, id).then(function(croppedFile){
        if(id === "logo") {
          const formData = new FormData();
          formData.append("method", "saveWebsiteLogo");
          formData.append("appId", localStorage.getItem("aiAppId"));
          formData.append("file", croppedFile);
          formData.append("live", app.config().live);
          
          fetch(`${config.apiFetch}/upload-logo`, {
            method:"POST",
            body:formData
          }).then(function(response) {
            response.json().then(function(response) {
              callback("src", `${app.config().bucket72}/media/user_space/${response.path}`);
              app.preloader(false);   
            });
          });
        }
        else {
          const formData = new FormData();
          formData.append("method", "saveCustomLogo");
          formData.append("appId", localStorage.getItem("aiAppId"));
          formData.append("customLogo", croppedFile);
          app.postForm(formData).then(function(response){
            console.log(response.data);
            if(response.data) {
              if(response.data.logo) {
                //localStorage.setItem("custom_app_icon_image", response.data.logo);
                localStorage.setItem("custom_app_icon_image", response.data.logo.split("/").pop());
                callback("src", response.data.logo);
                app.preloader(false);   
              }
            }
          });
        }
     
      }).catch(function(){
        alert("Please select valid file");
        app.preloader(false);   
      })
      // const file = event.currentTarget.files[0];
      // app.preloader(true);
      // app.validateImage(file, 1024, 1024).then(function(){
        
      // }).catch(function(){
      //   alert("The maximum image upload size recommended is 1024X1024");
      //   app.preloader(false);
      // });
    }
  },
  saveAILogo:async function(businessName, feature) {
    console.log("saveAILogo");
    // Invoked fire-and-forget from the divKit messageHandler
    // (src/pages/divKit.js, type === "saveAILogo"), so nothing catches a
    // rejection and every await below could surface as an unhandled rejection.
    // Logo generation is best-effort — log and return null rather than throw.
    try {
      let response = await fetch(`${config.apiFetch}/generate-image`, {
        method:"POST",
        body:JSON.stringify({
          "method":"generateLogo2",
          "appId":localStorage.getItem("aiAppId"),
          businessName,
          feature,
          "live":app.config().live
        })
      });
      response = await response.json();

      // The generate step doesn't always return an image URL. fetch(undefined)
      // resolves "undefined" against the current origin and fails confusingly,
      // so bail out explicitly instead.
      if(!response || !response.fetchUserImage) {
        console.warn("app.saveAILogo: response has no fetchUserImage, aborting", response);
        return null;
      }

      const blobImage = await fetch(response.fetchUserImage);
      const croppedFile = await blobImage.blob();

      const formData = new FormData();
      formData.append("method", "saveCustomLogo");
      formData.append("appId", localStorage.getItem("aiAppId"));
      formData.append("customLogo", new File([croppedFile],  Date.now() + ".png",  { type: "image/png" }));
      //formData.append("customLogo", croppedFile);
      const res = await app.postForm(formData);

      await app.updateLogoHeaderFooter(response.image, businessName);

      // Host-page global — not guaranteed to be defined.
      if(typeof window.headerFooterHTML === "function") {
        window.headerFooterHTML(function(){

        });
      }
      return res;
    }
    catch(err) {
      console.warn("app.saveAILogo failed", err);
      return null;
    }
  },
  updateLogoHeaderFooter:async function(image, businessName) {
    let fetchItems = ["getHeader", "getFooter"];
    const values = await Promise.all(fetchItems.map(function(v){
        return app.fetchPost({ method:v, appId:localStorage.getItem("aiAppId"), userId:"123456" }, true);
    }));

    values[0].headerData = JSON.parse(values[0].headerData);
    values[1].footerData = JSON.parse(values[1].footerData);

    values[0].headerData.elements.logo.properties.show = false;
    values[0].headerData.elements.logo.properties.showWeb = true;
    values[0].headerData.elements.logo.properties.src = image;
    values[0].headerData.elements.logo.properties.showLogo = true;
    values[0].headerData.elements.logo.properties.showLogoWeb = true;
    values[0].headerData.elements.logo.text = businessName;
    values[0].headerData.elements.headerText.text = businessName;
    

    values[1].footerData.elements.logo.properties.src = image;
    values[1].footerData.elements.logo.text = businessName;

    

    let saveItems = [{
      "method": "saveHeader",
      "headerJson": JSON.stringify(values[0].headerData)
    }, {
      "method":"saveFooter",
      "footerJson": JSON.stringify(values[1].footerData)
    }];

    const saveValues = await Promise.all(saveItems.map(function(v){
      v["appId"] = localStorage.getItem("aiAppId");
      v["userId"] = "123456";
      return app.fetchPost(v, true);
    }));

    return saveValues;

  },
  blockPopup:function(callback) {
      const div = document.createElement("div");
      document.body.appendChild(div);
      ReactDOM.render(<Blocks callback={callback} />, div);
  },
  ///iPhone|iPad|iPod|Android
  isMobile:function() {
    ///iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    if (isMobile) {
        document.body.classList.add("isMobileEnable")
        return "is-mobile";
    }
    else {
        return "";
    }
},
  config:function() {
   return config;
  },
  cdn:function(text) {
    if(text) {
      return text.replaceAll("__CDN__PATH__", `${app.config().bucket}/`);
    }
    return text;
  },
  fonts:function(){
    return new Promise(function(resolve, reject){
        // if(localStorage.getItem("fonts")) {
        //     resolve(JSON.parse(localStorage.getItem("fonts")))
        // }
        // else {
            window.fetch('https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyBEMxevrXHc6tk7-B7qYpMwfqBEEDzWA5M')
            .then((response) => response.json())
            .then(function(data){
              let fn = data.items.filter(function(v){
                  return v.family !== "Material Icons";
              }).map(function(v){
                  return v.family;
              }); 
              localStorage.setItem("fonts", JSON.stringify(fn))
              resolve(JSON.parse(localStorage.getItem("fonts")))
            });
       //}
    })
    },

     sanitizeHTML:function(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // ❌ Tags to remove completely
      const REMOVE_TAGS = ['IFRAME', 'SVG', 'IMG', 'SCRIPT', "VIDEO", "STYLE", "LINK", "OBJECT", "EMBED", "FORM", "INPUT", "BUTTON", "TEXTAREA", "SELECT", "META"];

      REMOVE_TAGS.forEach(tag => {
        doc.querySelectorAll(tag).forEach(el => el.remove());
      });

      // Clean attributes
      doc.body.querySelectorAll('*').forEach(v => {
        [...v.attributes].forEach(attr => {
          const name = attr.name.toLowerCase();
          const value = attr.value.toLowerCase();

          // ❌ Remove inline JS events
          if (name.startsWith('on')) {
            v.removeAttribute(attr.name);
          }

          // ❌ Remove javascript: links
          if (name === 'href' && value.includes('javascript:')) {
            v.removeAttribute('href');
          }
        });

        // ❌ Remove risky / unwanted attributes
        v.removeAttribute('style');
        v.removeAttribute('class');
        v.removeAttribute('contenteditable');
      });

      return doc.body.innerHTML;
    },
    htmlPaste:function(e){
      let html = e.clipboardData.getData('text/html');
      if(e.clipboardData.getData('text/plain')) {
          html = e.clipboardData.getData('text/plain');
      }
      
      if(html) {
          html = app.sanitizeHTML(html);
          if(e.currentTarget.classList.contains("editor-area")) {
              document.execCommand("insertHTML", false, html);
          }
          else {
              app.getDom().execCommand("insertHTML", false, html);
          }
      }
      e.preventDefault();
    },
    scroll:function(callback) {
      app.getWin().addEventListener('scroll', function(event) {
          callback(app.getWin().scrollY + 0);
      }, false);
  },
  scrollTop:function(y) {
    app.getDom().body.scrollTop +=   y;
  },
  getDevice:function() {
     if(localStorage.getItem("device") === "mobile") {
       return false;
     }
     return  true;
  }, 
  getProject:function() {
    const {host} = window.location;
    if(host === "admin.mediadirhub.com") {
      return "admin";
    }
    else if(host === "pages.mediadirhub.com") {
      return "pages";
    }
    else if(host === "templates.mediadirhub.com") {
      return "templates";
    }
    else if(host.indexOf("appypie.com") !== -1 || host.indexOf("pbodev.info") !== -1) {
      return "live";
    }
    else if(host === "localhost:3000") {
      return "live";
    }
    return "live";
  },
  // True on white-label reseller domains, and tags <body> with `reseller-view`
  // so CSS can hide Appy Pie branding. Same host test getProject() uses above:
  // appypie.com / pbodev.info are ours, anything else is a reseller — so a new
  // reseller domain needs no code change here.
  //
  // NOT the same thing as isReseller() further down: that one reads the
  // server's billing flag out of localStorage and drives the credits UI. This
  // one only looks at the URL, so keep the two separate.
  isResellerDomain:function() {
    if(typeof window === "undefined") return false;
    const {host} = window.location;
    if(host.indexOf("appypie.com") !== -1 || host.indexOf("pbodev.info") !== -1) {
      return false;
    }
    // Called from module scope in index.js so the class lands before first
    // paint — at that point <body> may not be parsed yet, hence the fallback.
    if(document.body) {
      document.body.classList.add("reseller-view");
    }
    else {
      document.addEventListener("DOMContentLoaded", function(){
        document.body.classList.add("reseller-view");
      });
    }
    return true;
  },
  fetchPost:async function(data, mode) {
    if(!mode) {
      app.preloader(true);
    }
    try {
      let response = await fetch(app.config().aiPostURL, {
        body:JSON.stringify({
            payload:cryptography.encrypt2(JSON.stringify(data))
        }),
        //body:JSON.stringify(data),
        method: "POST",
        headers:{
          'Content-Type': 'application/json'
        }
      });
      response = await response.json();
      response = JSON.parse(cryptography.decrypt2(response.data));

      //console.log(data, response);

      return response;
    }
    catch(err) {
      // Name the endpoint and the method being called. All 75 call sites share
      // this one fetch, so a bare "TypeError: Failed to fetch" collapses into a
      // single Sentry issue with nothing to act on.
      throw new Error(`fetchPost(${(data && data.method) || "unknown"}) failed: ${err && err.message}`, { cause: err });
    }
    finally {
      // Always release the preloader. A rejected fetch used to skip the
      // preloader(false) below it, leaving the full-screen spinner up for good
      // — a hung app with no way forward on any flaky connection.
      // Sentry AI-BUILDER-9B / AI-BUILDER-9A.
      if(!mode) {
        app.preloader(false);
      }
    }
 },
 
 fetchLivePost:async function(data, mode) {
  if(!mode) {
    app.preloader(true);
  }
  let url = "https://snappy.appypie.com/webservices/aiEditorService.php";
  try {
    let response = await fetch(url, {
      method:"POST",
      body:JSON.stringify(data)
    })
    response = await response.json();
    return response;
  }
  catch(err) {
    throw new Error(`fetchLivePost(${(data && data.method) || "unknown"}) failed: ${err && err.message}`, { cause: err });
  }
  finally {
    // Same stuck-spinner fix as fetchPost above.
    if(!mode) {
      app.preloader(false);
    }
  }
},
setupPlugins:async function(email) {
  // 1. encrypt request
  const data = cryptography.encrypt2(JSON.stringify({
    email,
    ts: Math.floor(Date.now() / 1000)
  }));

  // 2. POST
  const res = await fetch(`${config.apiFetch}/setup-plugins`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data })
  });
  const body = await res.json();

  // 3. decrypt response
  if (body.data) {
    const plaintext = cryptography.decrypt2(body.data);
    const result = JSON.parse(plaintext);
    console.log(result);   // { status: "ok", email, prefix, resources: {...} }
    return result;
  }
  console.error("setupPlugins error:", body);
  return null;
},
  postForm:async function(data, mode) {
    if(!mode) {
      app.preloader(true);
    }
    data.append("encrypt", true);
    try {
      let response = await fetch(app.config().aiPostURL, {
        method:"POST",
        body:data
      })
      response = await response.json();
      response = JSON.parse(cryptography.decrypt2(response.data));
      return response;
    }
    catch(err) {
      throw new Error(`postForm failed: ${err && err.message}`, { cause: err });
    }
    finally {
      // Same stuck-spinner fix as fetchPost above. This path uploads files, so
      // it is the most likely of the three to die on a slow connection.
      if(!mode) {
        app.preloader(false);
      }
    }
  },
  loadImage:function(text, callback) {
    app.preloader(true);
    return fetch("https://api-fetch.mediadirhub.com/vectorize", {
      method:"POST",
      body:JSON.stringify({
        method:"getTextImage",
        text:text
      })
    }).then(function(response){
      return response.json().then(function(response){
        callback(response);
      })
    }).catch(function(err){
      // Same stuck-spinner fix as fetchPost. The callback is deliberately not
      // invoked on failure — callers treat its argument as a decoded image.
      console.error("loadImage failed:", err);
      throw new Error(`loadImage failed: ${err && err.message}`, { cause: err });
    }).finally(function(){
      app.preloader(false);
    })
  },
  setFonts:function(response) {
      let setFonts = [];
      response.dynamicAIData.forEach(function(v){
        for(var k in v.elements) {
            if(v.elements[k]["properties"]["fontFamily"]) {
                if(v.elements[k]["properties"]["fontFamily"] !== "") {
                    setFonts.push(v.elements[k]["properties"]["fontFamily"]);
                }
            }
            if(v.elements[k].viewType === "grid") {
                v.elements[k].items.forEach(function(val){
                    
                    for(var key in val) {
                        //console.log(key, val[key])
                        if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]["fontFamily"]) {
                                if(val[key]["properties"]["fontFamily"] !== "") {
                                    setFonts.push(val[key]["properties"]["fontFamily"]);
                                }
                            }
                        } 
                    }
                })
            }
        }
      })
    setFonts = [...new Set(setFonts)]
    setFonts = setFonts.map(function(v){
       return v.replace(/ /g,"+");
     }).join(":wght@400;600;700&family=");
     //console.log(setFonts);
    let fontLink = app.getDom().querySelector("#googleFonts");
    if(!fontLink) {
      
      fontLink = document.createElement("link");
      fontLink.setAttribute("rel", "stylesheet");
      fontLink.setAttribute("id", "googleFonts");
      //link.setAttribute("href", file);
      app.getDom().head.appendChild(fontLink);
      
    }

    fontLink.setAttribute("href", `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`)
        
  },
  setFontsLive:function(response) {
    let setFonts = [];
    response.dynamicAIData.forEach(function(v){
      for(var k in v.elements) {
          if(v.elements[k]["properties"]["fontFamily"]) {
              if(v.elements[k]["properties"]["fontFamily"] !== "") {
                  setFonts.push(v.elements[k]["properties"]["fontFamily"]);
              }
          }
          if(v.elements[k].viewType === "grid") {
              v.elements[k].items.forEach(function(val){
                  
                  for(var key in val) {
                      //console.log(key, val[key])
                      if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                          if(val[key]["properties"]["fontFamily"]) {
                              if(val[key]["properties"]["fontFamily"] !== "") {
                                  setFonts.push(val[key]["properties"]["fontFamily"]);
                              }
                          }
                      } 
                  }
              })
          }
      }
    })
  setFonts = [...new Set(setFonts)]
  setFonts = setFonts.map(function(v){
     return v.replace(/ /g,"+");
   }).join(":wght@400;600;700&family=");
   //console.log(setFonts);
  let fontLink = document.querySelector("#googleFonts");
  if(!fontLink) {
    
    fontLink = document.createElement("link");
    fontLink.setAttribute("rel", "stylesheet");
    fontLink.setAttribute("id", "googleFonts");
    //link.setAttribute("href", file);
    document.head.appendChild(fontLink);
    
  }

  fontLink.setAttribute("href", `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`)
      
  },
  setFontsLive2:function(response) {
    let setFonts = [];
    response.forEach(function(v){
      for(var k in v.elements) {
          if(v.elements[k]["properties"]["fontFamily"]) {
              if(v.elements[k]["properties"]["fontFamily"] !== "") {
                  setFonts.push(v.elements[k]["properties"]["fontFamily"]);
              }
          }
          if(v.elements[k].viewType === "grid") {
              v.elements[k].items.forEach(function(val){
                  
                  for(var key in val) {
                      //console.log(key, val[key])
                      if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                          if(val[key]["properties"]["fontFamily"]) {
                              if(val[key]["properties"]["fontFamily"] !== "") {
                                  setFonts.push(val[key]["properties"]["fontFamily"]);
                              }
                          }
                      } 
                  }
              })
          }
      }
    })
  setFonts = [...new Set(setFonts)]
  setFonts = setFonts.map(function(v){
     return v.replace(/ /g,"+");
   }).join(":wght@400;600;700&family=");
   
  

  return `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`;
      
  },
  preloader:function(mode) {
    if(document.querySelector(".app-loader")) {
      if(mode) {
        document.querySelector(".app-loader").style.display = "block";
      }
      else {
        document.querySelector(".app-loader").style.display = "none";
      }
    }
 },
  isOnline() {
    if (navigator.onLine) {
      return true;
    } else {
      return false;
    }
  },
  fetchBuilder:async function(data, mode){
    if(!mode) {
      app.preloader(true);
    }
    try {
      let response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
          method:"POST",
          body:JSON.stringify(data)
      });
      response = await response.json();
      if(!mode) {
        app.preloader(false);
      }
      return response;
    } catch (error) {
      if(!mode) {
        app.preloader(false);
      }
    }
  },
  getColor:function(argb){
    if(argb) {
      if(argb.length === 7) {
        return argb;
      }
      else {
        return argb.replace(argb.substr(1, 2), "") + argb.substr(1, 2);
      }
      // console.log("argb", argb, argb.length)
      // // console.log("alpha", argb.substr(1, 2))
      // // console.log("red", argb.substr(3, 2))
      // // console.log("green", argb.substr(5, 2))
      // // console.log("blue", argb.substr(7, 2))
      // let red, green, blue, alpha, alphaFraction = "";
      // if(argb.length === 7){
        
      //   red = parseInt(argb.substr(1, 2), 16);
      //   green = parseInt(argb.substr(3, 2), 16);
      //   blue = parseInt(argb.substr(5, 2), 16);

      //   console.log('inside 7',argb, red, green, blue)  
      // }else if(argb.length > 7){
      //   alpha = parseInt(argb.substr(1, 2), 16);
      //   red = parseInt(argb.substr(3, 2), 16);
      //   green = parseInt(argb.substr(5, 2), 16);
      //   blue = parseInt(argb.substr(7, 2), 16); 
      //   alphaFraction = (alpha / 255).toFixed(2); 
      // } 
      // return `rgba(${red}, ${green}, ${blue}, ${alphaFraction})`;
    }
    return "";
  },
  getPlanColor:function(argb){
    if(argb) {
      if(argb.length === 7) {
        return argb;
      }
      else {
        return argb.replace(argb.substr(1, 2), "");
      } 
    }
    return "";
  },
  combineColor(color, opacity) {
    console.log("color, opacity", color, opacity); 
    opacity = Math.max(0, Math.min(100, opacity));
    
    // Convert opacity to a 2-digit hex value
    let newAlpha = Math.round((opacity / 100) * 255).toString(16).padStart(2, '0').toUpperCase();
    
    // Check if the color has 8 characters (including the '#')
    if (color.startsWith('#') && color.length === 9) {
      let existingAlpha = color.substring(1, 3);
      let rgb = color.substring(3); 
      return `#${newAlpha}${rgb}`;
    }
    
    // Check if the color has 7 characters (including the '#')
    if (color.startsWith('#') && color.length === 7) {
      let rgb = color.substring(1);
      return `#${newAlpha}${rgb}`;
    } 
    console.error("Invalid color format: Must be in the format #RRGGBB or #AARRGGBB");
    return color; // Return the original color if invalid
  },   
  getOpacity(color) {
    if (color) {
      if (typeof color === 'string' && color.startsWith('#') && color.length === 9) {
        const alphaHex = color.substring(1, 3); // Extract AA
        const alphaDecimal = parseInt(alphaHex, 16) / 255; // Convert to decimal and normalize
        const opacityPercentage = alphaDecimal * 100; // Convert to percentage
        return Math.floor(opacityPercentage); // Return the integer part only
      }
      return 100; // Default opacity if the color format is not as expected
    }
  },
  rgbaToHex(rgba) { 
    console.log("rgba", rgba)
    if (rgba && rgba.startsWith("#")) { 
      if (rgba.length === 7) {
          return rgba;
      } else {
        return rgba.replace(rgba.substr(1, 2), "") + rgba.substr(1, 2);
      } 
    }
    
    const parts = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+),\s*(\d*\.?\d+)?\)$/);
    console.log("coming-rgbaToHex-parts", parts);

    if (!parts) {
      return null;
    }

    // Convert each component to hexadecimal
    let r = parseInt(parts[1]).toString(16).padStart(2, '0');
    let g = parseInt(parts[2]).toString(16).padStart(2, '0');
    let b = parseInt(parts[3]).toString(16).padStart(2, '0');

    // Handle alpha (opacity)
    let a = parts[4] ? Math.round(parseFloat(parts[4]) * 255).toString(16).padStart(2, '0') : '';

    // console.log("rgbaToHex", a, r, g, b); 
    return `#${a}${r}${g}${b}`;
  },
  isValidColor(value) {
    // Check if the value is a valid hex color
    return /^#[0-9A-Fa-f]{6}$/.test(value);
  },
  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  },
  // Resolves once the script is actually executable, not merely present.
  //
  // This used to resolve as soon as a tag with this id existed in the DOM. That
  // is a race: a second caller arriving while the first tag is still in flight
  // resolved immediately and then reached for a global the script had not
  // defined yet — Sentry AI-BUILDER-97, "window.ace.edit is not a function",
  // where two components (htmlEditor.js and jsonEditor.js) both request "ace".
  // Tags created here carry a load-state marker so later callers can tell an
  // in-flight tag from a finished one.
  loadScript:function(src, id) {
    const existing = document.querySelector("#" + id);

    if(existing) {
      const state = existing.dataset.loadState;

      if(state === "loaded") {
        return Promise.resolve();
      }
      if(state === "error") {
        return Promise.reject(new Error(`loadScript: ${id} previously failed to load (${src})`));
      }
      if(state === "loading") {
        return new Promise((resolve, reject) => {
          existing.addEventListener("load", () => resolve());
          existing.addEventListener("error", () => reject(new Error(`loadScript: failed to load ${id} (${src})`)));
        });
      }
      // A tag we did not create (hand-placed in index.html). There is no way to
      // know whether it has already run, and waiting on a "load" event that may
      // have fired long ago would hang forever, so keep the old optimistic
      // behaviour for this case only.
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const tag = document.createElement("script");
      tag.async = true;
      tag.src = src;
      tag.id = id;
      tag.dataset.loadState = "loading";

      tag.addEventListener("load", () => {
        tag.dataset.loadState = "loaded";
        resolve();
      });

      tag.addEventListener("error", () => {
        tag.dataset.loadState = "error";
        // Reject with a real Error — a bare reject() surfaces in Sentry as an
        // unactionable "Non-Error promise rejection captured".
        reject(new Error(`loadScript: failed to load ${id} (${src})`));
      });
      document.head.appendChild(tag);
    })
  },
  getItemValue(data, key) {
    if(data.viewType === "view") {
      let value = undefined;
      if(data["properties"][key]) {
        value = data["properties"][key];
      }
      // for(var k in data.elements) {
      //   if(data.elements[k]["properties"][key]) {
      //     value = data.elements[k]["properties"][key];
      //   }
      // }
      return value;
    }
    else if(data.viewType === "gridItem") {
      let value = undefined;
      if(data["properties"][key]) {
        value = data["properties"][key];
      }
      // console.log(data);
      // for(var k in data) {
      //   if(["gridItem", "properties", "gridId", "viewId", "viewType"].indexOf(k) === -1) {
      //     value =  data[k]["properties"][key];
      //   }
      // }
      return value;
    }
  },
  getAllMaster:async function() {
    return await app.fetchLivePost({"method":"getAllMaster"});
  },
  getMaster(id, callback) {
    app.getAllMaster().then(function(response){
      let block = null;
      if(response.data) {
        response.data.forEach(function(v){
          if(v.title === id) {
            block = v;
          }
        })
      }
      callback(block);
    });
  },
  getPage(id, callback) {
    app.fetchPost({
      "method":"getAllPages",
      "lang":"en"
    }).then(function(response){
      let itemData = null;
      if(response.data) {
          response.data.forEach(function(v){
              if(v.id === id) {
                  itemData = v;
              }
          });
      }
      callback(itemData);
    })
  },
  
  toast:function(txt) {
    const div = document.createElement("div");
    div.setAttribute("class", "toast show align-items-center text-white bg-success border-0 position-fixed end-0 bottom-0 m-2");
    div.style.zIndex = "99999";
    div.innerHTML = `
    <div class="d-flex">
    <div class="toast-body">
      ${txt}
    </div>
  </div>
    `
    document.body.appendChild(div);
    setTimeout(function(){
      div.remove();
    }, 3000)
  },
  getLang:function(key) {
    // getConfig() falls back to the bundled src/config.json when nothing is
    // cached in localStorage, and that file has no languageSettings key — so
    // this was `undefined[key]` and threw. Default to {} and let the existing
    // key-passthrough below supply a readable label.
    let langSettings = app.getConfig().languageSettings || {};
    if(langSettings[key]) {
      return langSettings[key];
    }
    return key;
  },
  saveUndo:function(next){
    let data  = [];
    if(localStorage.getItem("undo")) {
        data = JSON.parse(localStorage.getItem("undo"));
    }
    if(data.length === 10) {
        data.shift();
    }
    data.push(next);
    localStorage.setItem("undo", JSON.stringify(data));
    // if(data.length) {
    //   if(next !== data[data.length - 1]) {
    //     data.push(next);
    //     localStorage.setItem("redo", JSON.stringify([]));
    //     localStorage.setItem("undo", JSON.stringify(data));
    //   }
    // }
    // else {
    //     data.push(next);
    //     localStorage.setItem("redo", JSON.stringify([]));
    //     localStorage.setItem("undo", JSON.stringify(data));
    // }
  },
  saveRedo:function(next){
    let data  = [];
    if(localStorage.getItem("redo")) {
        data = JSON.parse(localStorage.getItem("redo"));
    }
    data.push(next);
    localStorage.setItem("redo", JSON.stringify(data));
 },
  getUndoRedo:function(type){
    let data  = [];
    if(localStorage.getItem(type)) {
        data = JSON.parse(localStorage.getItem(type));
    }
    return data;
  },
  setUndoRedo:function(type, data){
      localStorage.setItem(type, JSON.stringify(data));
  },
  resizeBlockView:function(type, data){
    setTimeout(function(){
      app.getDom().querySelectorAll(".block").forEach(function(v, i){
        if(document.querySelectorAll(`.block-view`)[i]) { 
          document.querySelectorAll(`.block-view`)[i].style.height = v.offsetHeight + "px";
        }
        if(v.offsetHeight < 150){
          if(i !== 0){
            if((app.getDom().querySelectorAll(".block").length - 1) === i) {
              if(document.querySelectorAll(`.block-view`)[i]){
                document.querySelectorAll(`.block-view`)[i].classList.add("small-last-child")
              }  
            }
          }
          
        } 
      })
    },500);
  },
  setPageBodyHeight:function(type, data){
    setTimeout(function(){
        let iframe = app.getDom();
        // get header height
        let getHeader = iframe.querySelector('[widget-type="headerAi"]');
        let getHeaderHeight = getHeader ? getHeader.offsetHeight : 0; 
        // let getHeaderHeight = getHeader.offsetHeight;

        // get footer height
        let getFooter = iframe.querySelector('[widget-type="footerAi"]');
        let getFooterHeight = getFooter ? getFooter.offsetHeight : 0;
        // let getFooterHeight = getFooter.offsetHeight;

        let editorPageBody = iframe.querySelector(".page_body")
       
        let headerFooterHeight = getHeaderHeight + getFooterHeight ;

        if(getHeader && getFooter){
          // setelementStyle
          editorPageBody.style.minHeight =  `calc(100vh - ${headerFooterHeight}px)`;
        }
    },500)
  },
  isParents(event, match) {
    const parents = [];
    const element = event.target;
    let mode = false;
    if (element.matches(`.${match}`)) {
      // console.log("Ravi ");
      mode = true;
    }
    let currentElement = element.parentNode;

    while (currentElement) {
      parents.push(currentElement);
      currentElement = currentElement.parentNode;
    }
    parents.pop();
    parents.pop();
    parents.forEach(function(v){
      // console.log(v);
      if(v.classList.contains(match)) {
        mode = true;
      }
    })
    // console.log(element, parents);
      return mode;
    },
    encrypt:function(data) {
      const secretInfo = app.getSecret();
      const key = CryptoJS.enc.Utf8.parse(secretInfo.apiSecret);
      const iv = CryptoJS.enc.Utf8.parse(secretInfo.apiIv);
      let cipher = CryptoJS.AES.encrypt(data, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      return cipher.toString();
    },
    decrypt:function(data) {
      const secretInfo = app.getSecret();
      const key = CryptoJS.enc.Utf8.parse(secretInfo.apiSecret);
      const iv = CryptoJS.enc.Utf8.parse(secretInfo.apiIv);
      let cipher = CryptoJS.AES.decrypt(data, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      return cipher.toString(CryptoJS.enc.Utf8);
    },
  
    getSecret:function() {
      const data = CryptoJS.AES.decrypt(`U2FsdGVkX19GhMg6SagmB8zDvIAAIY8M/OjMwqY1z8a9KQaQHjuKx/Tq6gauzKkX943V/T9cgKMPw8CSsSbtx4zZwvAyI8KFmLqRrjsVXjntFtC1o2f3ev9afNx/k8oVQPi1p5pbVMCm3WpC1BQv3/9CChQXGwSI1pWQfJ9fYqQ=`, '8xFC81{2K"iGmkz/');
      return JSON.parse(data.toString(CryptoJS.enc.Utf8));
    },
    encryptFetch:async function(data){
      console.log(data);
      app.preloader(true)
      const postData = JSON.stringify(data)
      let response = await fetch("https://api-fetch.mediadirhub.com/text-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      app.preloader(false)
      return JSON.parse(app.decrypt(await response.text()));
    },
    textGeneration:async function(text){
      const currency = localStorage.getItem("userCurrency")?localStorage.getItem("userCurrency"):"USD";
      return app.encryptFetch({
        "method":"getText","text":text, "userId":localStorage.getItem("userId"), "appId":localStorage.getItem("aiAppId"), "currency":currency
      });
    },
    imageGeneration :async function(data){
      app.preloader(true)
      const postData = JSON.stringify(data)
      let response = await fetch("https://api-fetch.mediadirhub.com/image-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      app.preloader(false)
      return JSON.parse(app.decrypt(await response.text()));
    },
    getPrice:async function(type, data){
      let currency = localStorage.getItem("userCurrencyCode")?localStorage.getItem("userCurrencyCode"):"";
      let userEmail = localStorage.getItem("userEmail")?localStorage.getItem("userEmail"):"";
      let country = localStorage.getItem("userCountryCode")?localStorage.getItem("userCountryCode"):"";
      if(window.location.hostname === "localhost") {
        currency = "USD";
        if(userEmail === "") {
          userEmail = "ravi@appypie.com";
        }
        country = "US";
      }
      const postData = {
        "method":type,"appId":localStorage.getItem("aiAppId"), "currency":currency, "email":userEmail, "country":country
      }
      if(data) {
        for(var key in data) {
          postData[key] = data[key];
        }
      }
      return app.encryptFetch(postData);
    },
    loadPages:async function(){
      // const response = await fetch("https://snappybeta.appypie.com/webservices/manifest-pwa.php", {
      //   method: 'POST',
      //   body: JSON.stringify({ method: "getApp", appId:localStorage.getItem("aiAppId"), prevVersion: "0" }),
      //   headers: {
      //       "Content-Type": "application/json"
      //   }
      // });
      const response = await fetch("https://api.mediadirhub.com/app/react-app-demo1.pwastore.com/1257/app");
      const data = await response.json();
      return data.home;
    },
    getTotalCredit:function(a){
      let totalCredit = 0;
      if(localStorage.getItem("textTotalCredit")) {
        totalCredit = parseInt(localStorage.getItem("textTotalCredit"));
      }
      if(a) {
        totalCredit = totalCredit + a;
        localStorage.setItem("textTotalCredit", totalCredit);
      }
      return totalCredit;
    },
    isReseller:function(){
      let isReseller = false;
      if(localStorage.getItem("isReseller")) {
        if(localStorage.getItem("isReseller") === "true") {
          isReseller = true;
        }
      }
      return isReseller;
    },
    
    // Strict "am I running on a developer's own machine" check. Only matches
    // the loopback hostnames — does NOT include staging hosts like pbodev.info
    // or 72snappynormal. For that broader "dev-like environment" check see is72().
    isLocalhost:function(){
      if(typeof window === "undefined") return false;
      const h = window.location.hostname;
      return h === "localhost" || h === "127.0.0.1" || h === "::1";
    },
    // Id for a navigationMenu item: 8 random base-36 characters, e.g. "7shtur7v".
    //
    // No timestamp: toLegacyMenu rebuilds every item inside one synchronous map,
    // so the clock never advances between them and Date.now() alone produced one
    // id for the whole menu (measured: 1 unique out of 5). Randomness is what
    // makes them distinct, so the timestamp only added length.
    //
    // 8 characters = 36^8 = ~2.8e12. The id only has to be unique within a single
    // menu, and at 200 items that is a ~1-in-2-billion collision chance; measured
    // 0 collisions across 200k menus and in a pool of 1,000,000 ids.
    //
    // padEnd because Math.random() occasionally yields a short fraction.
    menuItemId:function(){
      return Math.random().toString(36).slice(2, 10).padEnd(8, "0");
    },
    is72:function(a){
      const isServer = typeof window === "undefined";
      if(!isServer) {
        const host = window.location.host;
        if(host.indexOf("pbodev.info") !== -1 || host.indexOf("72snappynormal.myapparea.com") !== -1 || host.indexOf("localhost") !== -1) {
          return true;
        }
        else {
          return false;
        }
      }
      return false;
    },
    isProject:function(){
      const isServer = typeof window === "undefined";
      if(!isServer) {
        const host = window.location.host;
        if(this.isLocalhost()) {
          return "local";
        }
        else if(host.indexOf("karma-trust-admin") !== -1) {
          return "admin";
        }
        else if(host.indexOf("pbodev.info") !== -1 || host.indexOf("72snappynormal.myapparea.com") !== -1) {
          return "pbodev";
        }
        else {
          return "live";
        }
      }
    },
    showAlert(type, message) {
     
      // Create alert element
      let success = "bg-success";
      if(type === "danger") {
        success = "bg-danger";
      }
      const alertDiv = document.createElement('div');
      alertDiv.setAttribute("class", `toast custom-alert ${success} align-items-center text-white border-0 fade show`);
      alertDiv.setAttribute('role', 'alert');
      alertDiv.innerHTML = `
        <div class="d-flex"> <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"></use></svg> <div class="toast-body">${message}</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close"></button></div>
      `;
      const removeAlert = () => {
        alertDiv.remove();
      };
  
      // Add event listener to the close button
      alertDiv.querySelector('.btn-close').addEventListener('click', removeAlert);
      
      // Append to body
      document.body.appendChild(alertDiv);
  
      // Automatically remove after 3 seconds
      setTimeout(() => {
        removeAlert();
      }, 3000);
    },
    videoPopup:function(properties, callback) {
      const div = document.createElement("div");
      document.body.appendChild(div);
      ReactDOM.render(<VideosModel properties={properties} callback={function(key, val){
        // console.log("videoPopup---key, val", key, val)
        callback(key, val);
        if(document.querySelector(".modal .modal-close")){
          document.querySelector(".modal .modal-close").click();
        } 
      }} />, div);
    },

    
    getYoutube: function(src) {
      return new Promise((resolve, reject) => {
        let data = {
          embed: null,
          thumb: null,
          error: null,
          src:src,
          videoId:null
        };
    
        // Regular expression to extract video ID from YouTube URL
        var videoid = src.match(/(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&\n?#]+)/);
    
        if (videoid !== null) {
          videoid[1] = videoid[1].replace("embed/", "").replace("?wmode=opaque", "");
          data.embed = "https://www.youtube.com/embed/" + videoid[1] + "?rel=0&showinfo=0&enablejsapi=1";
          data.thumb = "https://img.youtube.com/vi/" + videoid[1] + "/hqdefault.jpg";
          data.videoId = videoid[1];
          resolve(data); // Resolve the Promise with data
        } else {
          data.error = "The YouTube URL is not valid.";
          reject(data); // Reject the Promise with data
        }
      });
    }
    ,

    getDailyMotion: function(src) {
      return new Promise((resolve, reject) => {
          let data = {
              embed: null,
              thumb: null,
              error: null,
              src:src,
              videoId:null
          };
          // let regex = /^.+dailymotion.com\/(video|embed)\/([^_&?/]+)/;
          let videoId = "";
          let m = src.match(/^.+dailymotion.com\/(video|hub|embed)\/([^_]+)[^#]*(#video=([^_&]+))?/);
          if (m !== null) {
              videoId = m[4] !== undefined ? m[4] : m[2];
          } 
  
          if (videoId) {
              data.embed = `https://www.dailymotion.com/embed/video/${videoId}?autoplay=0&mute=1`;
              data.thumb = `https://www.dailymotion.com/thumbnail/video/${videoId}`;
              data.videoId = videoId;
              resolve(data); 
          } else {
              data.error = "The Dailymotion URL is not valid.";
              reject(data);
          }
      });
  },
 

    getVimeo: async function (src) { 
      var id = src.substr(src.lastIndexOf("/") + 1);
      let data = {  
          embed: "https://player.vimeo.com/video/" + id,
          thumb: null,
          error: null,
          src:src,
          videoId:id
      };
      
      try {
          let response = await fetch("https://vimeo.com/api/v2/video/" + id + ".json");
          if (response.ok) {
              let videoData = await response.json();
              data.thumb = videoData[0].thumbnail_large; 
          } else {
              throw new Error("Failed to fetch video data");
          }
      } catch (error) {
          data.error = error.message;
          console.error("Error:", error);
      } 
      return data;
    },

    getScreenshot: async function (website) {
      const postData = JSON.stringify({
        method:"saveWebImage",
        website
      })
      let response = await fetch("https://api-fetch.mediadirhub.com/screenshot-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      return JSON.parse(app.decrypt(await response.text()));
    },
    textSearch:async function(pageId, searchText, controller) {
      try {
        let response = await fetch(app.config().postURL, {
          signal: controller.signal,
          method:"POST",
          body:JSON.stringify({
            "appId": localStorage.getItem("aiAppId"), 
            "pageId": pageId, 
            "searchText": searchText,
            "method" : "storeDeepLink"
          })
        })
        response = await response.json();
        if(response.data) {
          response.data = response.data.filter(function(v){
            if(v.status === 0) {
              return false;
            }
            return true;
          })
        }
        return response;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    iconsFilter:function(type){
      let pages = [];
      if(localStorage.getItem("featurePages")) {
        pages = JSON.parse(localStorage.getItem("featurePages"));
      }
      const data = {
        cart:["ecommerce", "dinein", "foodcourt", "foodordering", "hyperstore", "digitalstore"],
        location:["auction", "dating", "datingrevamp", "dinein", "event", "foodcourt", "hyperlocal", "loyaltycard", "loyalty","services", "taxi-ride", "demanddelivery"],
        notification:["notification"]
      }
      let mode = "";
      if(type === "cart") {
        mode = "cart-no";
        pages.forEach(function(v){
          if(data[type].indexOf(v.pageIdentifier) !== -1) {
            mode = "cart-yes";
          }
          if(data[type].indexOf(v.pageid) !== -1) {
            mode = "cart-yes";
          }
        })
      }
      if(type === "location") {
        mode = "location-no";
        pages.forEach(function(v){
          if(data[type].indexOf(v.pageIdentifier) !== -1) {
            mode = "location-yes";
          }
          if(data[type].indexOf(v.pageid) !== -1) {
            mode = "location-yes";
          }
        })
      }
      if(type === "notification") {
        mode = "notification-yes";
        // mode = "notification-no";
        // pages.forEach(function(v){
        //   if(data[type].indexOf(v.pageIdentifier) !== -1) {
        //     mode = "notification-yes";
        //   }
        //   if(data[type].indexOf(v.pageid) !== -1) {
        //     mode = "notification-yes";
        //   }
        // })
      }
      return mode;
    },  
    phoneKeyDown(event) {
      const allowedKeys = [
        'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', // Navigation keys
        '-', '+', // Signs
      ];
  
      // Allow control keys and navigation keys
      if ((allowedKeys.includes(event.key) || (event.key >= '0' && event.key <= '9'))) {
          return; // Allow the key
      }
      
  
      // Prevent other keys
      event.preventDefault();
    },
    isWebsiteBuilder:function(){
      const isServer = typeof window === "undefined";
      if(!isServer) {
        if(window.location.pathname === "/website/creator-software/build"){
          return true;
        }
      }
      return false; 
    },
    allowOnlyImages:function(file) {
      //const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      const allowedTypes = ['image/jpeg', 'image/png'];
      //alert(file.type);
      if (!allowedTypes.includes(file.type)) {
        //alert(app.getLang("onlyAllowedFormats"));
        //input.value = ''; // Clear the input
        return false;
      }
      return true; // All files are valid images
    },
  
  checkDivkit:function() {
    const isServer = typeof window === "undefined";
    const appIds = ["f47f00ae18cc", "7b2bc7e2179c", "fdb02d4ba9b1", "ea3d315e73d2", "cc1a6914fd42", "636069b17624"];
    const divkitPages = ["homenew_", "aiarticle_", "contactai_", "aboutai_"];
    let isAppkit = false;
    
    if(!isServer) {
      if(localStorage.getItem("aiPageId")) {
        if(appIds.includes(localStorage.getItem("aiAppId"))) {
          if(localStorage.getItem("aiPageId").indexOf("home_") === 0) {
            isAppkit = true;
          }
        }
        divkitPages.forEach(function(v){
          if(localStorage.getItem("aiPageId").indexOf(v) === 0) {
            isAppkit = true;
          }
        });
      }
    }
    return isAppkit;
  },
  checkPlugin:function() {
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(localStorage.getItem("aiPageId")) {
        if(localStorage.getItem("aiPageId").indexOf("aifeature_") === 0) {
          return true;
        }
      }
    }
    return false;
  },
  checkHtmlEditor:function() {
    const isServer = typeof window === "undefined";
    if(!isServer) {
      const pageId = localStorage.getItem("aiPageId");
      if(pageId && pageId.indexOf("htmlcode_") === 0) {
        return true;
      }
    }
    return false;
  },
  // True when the signed-in user is one of the app owners. Gates the HTML
  // editor's JS tab — running arbitrary script on a published page is for the
  // owners, not every editor. Compared lower-case because the list is
  // lower-case and localStorage carries whatever the login supplied.
  isDonaldApp:function() {
    const isServer = typeof window === "undefined";
    if(isServer) return false;
    const ownerEmails = [
      "murli@appypie.com",
      "admin@reocpareview.ph",
      "testqa.delhi21@gmail.com",
      "ravi@appypiellp.com"
    ];
    const email = (localStorage.getItem("userEmail") || "").trim().toLowerCase();
    if(!email) return false;
    return ownerEmails.indexOf(email) !== -1;
  },
  testingApp:function() {
    const isServer = typeof window === "undefined";
    if(!isServer) {
      if(["f47f00ae18cc", "03b844db334e", "c2f5a37461f4", "9122b8de1cd4", "ea3d315e73d2"].indexOf(localStorage.getItem("aiAppId")) !== -1){
        document.body.classList.add("testingApp")
      }
    }
  },
  featurePages:async function() {
    const response = await app.fetchPost({"method":"getAllFeaturePages","appId":localStorage.getItem("aiAppId")});
    return response.data;
  },
  appkitPages:async function(page, id, category) {
    const fetchURLs = {
      "blog_list":{
        "url":"https://72snappy.pbodev.info/webservices/Blog.php",
        "data":{
          "method":"articleList",
          "appId":localStorage.getItem("aiAppId"),
          "pageIdentifire":id,
          "page":1,
          "count":10
        },
        "keys":{
          "id": "id",
          "image": "",
          "title": "title",
          "year": "pubdate",
          "description": "metaDescription"
        }
      },
      "hyperstore_categories":{
         "url":"https://hyperstore.appypie.com/v1/home/get-landing-page-data",
          "data":{
            "appId": localStorage.getItem("aiAppId"),
            "pageId": id,
            "userId": 0, 
            "pageNum":1
          },
          "keys":{
            "id": "_id",
            "image": "imagePath",
            "name": "name"
          }
       
      },
      "hyperstore_products":{
         "url":"https://hyperstore.appypie.com/v1/home/get-landing-page-data",
          "data":{
            "appId": localStorage.getItem("aiAppId"),
            "pageId": id,
            "userId": 0, 
            "pageNum":1
          },
          "keys":{
            "id": "",
            "image": "",
            "name": "productName",
            "description": "brandName",
            "currency": "$",
            "price": "productPrice",
            "rating":"0"
          }
       
      }
    }
    const nextId = `${page}_${category}`
    let response = await fetch(fetchURLs[nextId].url, {
      method: "POST",
      headers:{
        'Content-Type': 'application/json'
      },
      body:JSON.stringify(fetchURLs[nextId].data)
    });
    response = await response.json();
    if(nextId === "blog_list") {
      const allKeys = fetchURLs[nextId].keys;
      return response.list.map(function(v){
        const nextData = {};
        for(var key in allKeys) {
          if(v[allKeys[key]]) {
            nextData[key] = v[allKeys[key]];
          }
        }
        nextData["image"] = "https://media.mediadirhub.com/images/default.png";
        if(v.mediaGallary) {
          if(v.mediaGallary[0]) {
            if(v.mediaGallary[0].imageUrl) {
              nextData["image"] = v.mediaGallary[0].imageUrl;
            }
          }
        }
        return nextData;
      })
    }
    if(nextId === "hyperstore_categories") {
      const allKeys = fetchURLs[nextId].keys;
      return response.data.categoryData.map(function(v){
        const nextData = {};
        nextData["image"] = "https://media.mediadirhub.com/images/default.png";
        for(var key in allKeys) {
          if(v[allKeys[key]]) {
            nextData[key] = v[allKeys[key]];
          }
        }
        return nextData;
      })
    }
    
    if(nextId === "hyperstore_products") {
      const allKeys = fetchURLs[nextId].keys;
      return response.data.latestProduct.map(function(v){
        const nextData = {};
        nextData["image"] = "https://media.mediadirhub.com/images/default.png";
        for(var key in allKeys) {
          if(v[allKeys[key]]) {
            nextData[key] = v[allKeys[key]];
          }
        }
        if(v.productImages) {
          if(v.productImages.defaultImage) {
            nextData["image"] = v.productImages.defaultImage;
          }
        }
        if(v.reviewRatings) {
          nextData["rating"] = v.reviewRatings.reviewAverage;
        }
        if(v.productPrice) {
          nextData["price"] = "";
        }
        nextData["price"] = "55";
        return nextData;
      })
    }

    

    

    return response;
  }

  
}



export default app

